<!-- 生成二维码的 组件 -->
<template>

<div :style="{ width: '200px', 'height': '200px' }">
    <vue-qr :text="qrUrl" qid="testid"></vue-qr>
    <a :href="qrUrl" target="_blank">查看详情</a>
    <!-- <vue-qrcode :value="qrUrl" type="image/png" :color="{ dark: '#00ffff', light: '#00ffff' }"></vue-qrcode>   -->
</div>
</template>
<script>

import VueQrcode from 'vue-qrcode' 
import VueQr from 'vue-qr'
export default {
    name:'QrDialog',
    components: {  
        VueQrcode,VueQr
    }, 
  

    props: {
    
        title: {
            // 弹窗标题
            type: String,
            default: ''
        },
        qrUrl:{
            // url地址
            type: String,
            default: ''
        },
        logoUrl:{
            // logo 图片的url地址
            type: String,
            default: ''
        }
    }
}
</script>